const specialReturnType = {
    generic: 'Generic'
};

export default specialReturnType;
